<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body" width="1000px">
      <div :class="[tableData.length > 0 ? 'dialog-scroller' : '']" style="display: flex;flex-direction: column;">
        <!--上传-->
        <div>
          <input id="mouldFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple accept=".xlsx, .xls" @change="handleClick" />
          <el-button size="mini" type="primary" icon="el-icon-document-add" @click="exportModel">
            {{ $t('xiazaimuban') }}
          </el-button>
          <el-button :loading="uploadLoading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
            {{ $t('piliangshangchuan') }}
          </el-button>
          <el-button :loading="uploadLoading" size="mini" type="default" icon="yicon yicon-export" @click="exportExcel('sheetjs', 'mouldImportExcel')">
            {{ $t('daochubaogao') }}
          </el-button>
        </div>
        <!--excel-->
        <div style="margin-top: 10px">
          <span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
            <i class="el-icon-link" />
            <span>{{ item }}</span>
            <i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)" />
          </span>
        </div>
        <!--表格-->
        <div id="mouldImportExcel" ref="table" style="flex: 1;margin-top: 10px;" v-loading="isLoading">
          <el-table border size="mini" :show-overflow-tooltip="true" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" :stripe="true" :max-height="tableHeight" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :label="item.label" :show-overflow-tooltip="true" :width="item.width">
              <template slot-scope="scope">
                <span>{{ scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length > 0" style="margin-top: 5px; display: flex; float: right; flex-direction: row-reverse" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :page-size="pagination.Z" layout="next, pager, prev, sizes , total" :total="tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" style="margin-right: 10px;" @click="visible = false">
          {{ $t('quxiao') }}
        </el-button>
        <el-button :loading="saveLoading" type="primary" size="mini" @click="importData">
          {{ $t('baocun') }}
        </el-button>
      </span>
      <!-- </div> -->
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      uploadLoading: false,
      saveLoading: false,
      excel: [],
      tableHeight: 0,
      tableData: [],
      tableColumn: [
        {
          label: this.$t('daorubaogao'),
          prop: 'result'
        },
        {
          label: this.$t('mujubianhao'),
          prop: 'no',
          width: 130
        },
        {
          label: this.$t('mujubianma'),
          prop: 'code',
          width: 130
        },
        {
          label: this.$t('mujumingcheng'),
          prop: 'name',
          width: 150
        },
        {
          label: this.$t('zhizaoshang'),
          prop: 'manufacturer',
          width: 150
        },
        {
          label: this.$t('zhizaoriqi'),
          prop: 'manufacturerDate',
          width: 150
        },
        {
          label: this.$t('mujushouming'),
          prop: 'lifetime',
          width: 100
        },
        {
          label: this.$t('earlyUsedLifetime'),
          prop: 'earlyUsedLifetime',
          width: 100
        },
        {
          label: this.$t('mujuweizhi'),
          prop: 'location',
          width: 150
        },
        {
          label: this.$t('chang*kuan*gao(CM)'),
          prop: 'volume',
          width: 150
        },
        {
          label: this.$t('zhongliang(KG)'),
          prop: 'weightText',
          width: 150
        },
        {
          label: this.$t('xiangmuhao'),
          prop: 'projectNo',
          width: 150
        },
        {
          label: this.$t('shifouzhumo'),
          prop: 'isDominantModeText'
        },
        {
          label: this.$t('shifouchanqianbaoyang'),
          prop: 'isPrepareMaintainText'
        },
        {
          label: this.$t('beizhu'),
          prop: 'remark'
        }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('daoru')
    };
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n;
        if (n == true) {
          this.countTableHeight();
        }
        if (n == false) {
          this.currentPage = 1;
        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false);
          this.tableData = [];
          this.excel = [];
        }
      },
      immediate: false
    }
  },
  methods: {
    countTableHeight() {
      this.tableHeight = 0;
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10;
        } else {
          this.tableHeight = 110;
        }
      });
    },
    exportModel() {
      window.open((process.env.NODE_ENV === 'development' ? global.URL_DEV_API_BASE_DOMAIN : process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN) + '/web/customer/files/viewFileByFileId/mujutaizhangdaorumuban');
    },
    importData() {
      const data = [...this.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      this.saveLoading = true;
      for (let i = 0; i < data.length; i++) {
        data[i]['status'] = 1;
        var volume = data[i]['volume'];
        if (volume != undefined || volume != null || volume != '') {
          let volume = data[i]['volume'].split('*');
          data[i]['length'] = parseInt((volume[0] * 10).toFixed(1));
          data[i]['width'] = parseInt((volume[1] * 10).toFixed(1));
          data[i]['heigth'] = parseInt((volume[2] * 10).toFixed(1));
        }
        var weight = data[i]['weightText'];
        if (weight != undefined && weight != null && weight != '') {
          data[i]['weight'] = parseInt(data[i]['weightText']) * 1000;
        }
        var isDominantModeText = data[i]['isDominantModeText'];
        if (isDominantModeText != undefined && isDominantModeText != null && isDominantModeText != '') {
          if (isDominantModeText == '是') {
            data[i]['isDominantMode'] = true;
          }
          if (isDominantModeText == '否') {
            data[i]['isDominantMode'] = false;
          }
        }
        var isPrepareMaintainText = data[i]['isPrepareMaintainText'];
        if (isPrepareMaintainText != undefined && isPrepareMaintainText != null && isPrepareMaintainText != '') {
          if (isPrepareMaintainText == '是') {
            data[i]['isPrepareMaintain'] = true;
          }
          if (isPrepareMaintainText == '否') {
            data[i]['isPrepareMaintain'] = false;
          }
        }

        data[i]['lifetime'] = data[i]['lifetime'] == null ? 0 : data[i]['lifetime'];
        data[i]['earlyUsedLifetime'] = data[i]['earlyUsedLifetime'] == null ? 0 : data[i]['earlyUsedLifetime'];
        delete data[i]['excel'];
      }
      if (this.listLength == null || this.listLength.length == 0) {
        return this.http
          .post('/web/basic/mould/batch/create?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.show = false;
            // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
            this.utils.event_hub.$emit('EQUIPMENT_MOULD_REFRESH');
          })
          .catch(error => {
            this.utils.errorMessage(error);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
        this.saveLoading = false;
      }
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({ header, results, name }) {
      const data = [];
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          };
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']]) {
              this.$set(item, this.tableColumn[j]['prop'], results[i][this.tableColumn[j]['label']]);
            }
          }
          var length = results[i]['长(CM)'];
          var width = results[i]['宽(CM)'];
          var height = results[i]['高(CM)'];
          let lwh = '';
          if (length != undefined) {
            lwh = lwh.concat(length + '*');
          } else {
            lwh = lwh.concat(0 + '*');
          }
          if (width != undefined) {
            lwh = lwh.concat(width + '*');
          } else {
            lwh = lwh.concat(0 + '*');
          }
          if (height != undefined) {
            lwh = lwh.concat(height);
          } else {
            lwh = lwh.concat(0);
          }
          console.log('lwh:', lwh);
          // let lwh = results[i]['长(CM)'] +"*" +results[i]['宽(CM)'] +"*" +results[i]['高(CM)']
          this.$set(item, 'volume', lwh);
          data.push(item);
        }
      }
      this.tableData = this.tableData.concat(data);
      this.excel.push(name);
      this.countTableHeight();
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    handleClick(e) {
      this.isLoading = true;
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        console.log(files[i]);
        this.beforeUpload(files[i]);
      }
      this.uploadLoading = true;
      document.getElementById('mouldFileInput').value = '';
      setTimeout(() => {
        let data = [...this.tableData];
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          data[i]['status'] = 1;
          var volume = data[i]['volume'];
          if (volume != undefined || volume != null || volume != '') {
            let volume = data[i]['volume'].split('*');
            data[i]['length'] = parseInt((volume[0] * 10).toFixed(1));
            data[i]['width'] = parseInt((volume[1] * 10).toFixed(1));
            data[i]['heigth'] = parseInt((volume[2] * 10).toFixed(1));
          }
          var weight = data[i]['weightText'];
          if (weight != undefined && weight != null && weight != '') {
            data[i]['weight'] = parseInt(data[i]['weightText']) * 1000;
          }
          var isDominantModeText = data[i]['isDominantModeText'];
          if (isDominantModeText != undefined && isDominantModeText != null && isDominantModeText != '') {
            if (isDominantModeText == '是') {
              data[i]['isDominantMode'] = true;
            }
            if (isDominantModeText == '否') {
              data[i]['isDominantMode'] = false;
            }
          }
          var isPrepareMaintainText = data[i]['isPrepareMaintainText'];
          if (isPrepareMaintainText != undefined && isPrepareMaintainText != null && isPrepareMaintainText != '') {
            if (isPrepareMaintainText == '是') {
              data[i]['isPrepareMaintain'] = true;
            }
            if (isPrepareMaintainText == '否') {
              data[i]['isPrepareMaintain'] = false;
            }
          }
          data[i]['lifetime'] = data[i]['lifetime'] == null ? 0 : data[i]['lifetime'];
          data[i]['earlyUsedLifetime'] = data[i]['earlyUsedLifetime'] == null ? 0 : data[i]['earlyUsedLifetime'];
          delete data[i]['excel'];
        }
        this.http
          .post('/web/basic/mould/batch/create?onlyValidate=true', data)
          .then(response => {
            if (response.msg === 'success') {
              this.isLoading = false;
            }
            this.listLength = response.data.validateItems;

            if (response.data.validateItems && response.data.validateItems.length > 0) {
              const list = response.data.validateItems;

              for (let i = 0; i < list.length; i++) {
                this.$set(this.tableData[Number(list[i]['index'])], 'result', list[i]['items'].join(','));
              }
            }
          })
          .catch(error => {
            this.utils.errorMessage(this.$t(error));
          })
          .finally(() => {
            this.uploadLoading = false;
            this.isLoading = false;
          });
      }, 800);
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false;
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false;
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false;
      }
      this.readerData(rawFile);
    },
    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = e => {
        const name = rawFile.name;
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const header = this.getHeaderRow(worksheet);
        const results = XLSX.utils.sheet_to_json(worksheet);
        this.generateData({
          header,
          results,
          name
        });
      };
      reader.readAsArrayBuffer(rawFile);
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell =
          sheet[
            XLSX.utils.encode_cell({
              c: C,
              r: R
            })
          ];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter(item => {
        return item !== name;
      });
      this.tableData = this.tableData.filter(item => {
        return item.excel !== name;
      });
    },
    exportExcel(file_name = 'sheetjs', id = this.randKey) {
      this.pagination.pageSize = 10000;
      let saveColumns = this.utils.deepCopy(this.columns);

      return new Promise(resolve => {
        this.isExportExcelt = true;
        this.loading = true;
        setTimeout(() => {
          /* 从表生成工作簿对象，加上raw就是单元格统一为string */
          var wb = XLSX.utils.table_to_book(document.querySelector('#' + id), {
            raw: true
          });
          /* 获取二进制字符串作为输出 */
          var wbout = XLSX.write(wb, {
            bookType: 'xlsx',
            bookSST: true,
            type: 'array'
          });
          try {
            FileSaver.saveAs(
              //Blob 对象表示一个不可变、原始数据的类文件对象。
              //Blob 表示的不一定是JavaScript原生格式的数据。
              //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
              //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
              new Blob([wbout], {
                type: 'application/octet-stream'
              }),
              //设置导出文件名称
              file_name + '.xlsx'
            );
          } catch (e) {
            if (typeof console !== 'undefined') console.log(e, wbout);
          }

          this.columns = saveColumns;
          this.loading = false;
          this.isExportExcelt = false;
          resolve(wbout);
          setTimeout(() => {
            this.pagination.pageSize = 10;
          }, 200);
        }, 300);
      });
    }
  }
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
